module.exports = __webpack_public_path__ + "assets/img/download-icon-button.79943fd2.svg";